import { getRegion, getCityId } from '@RootCommon/utils'
import WebVitalsSDK from '@sailor/web-vitals-sdk'

// SDK 实例
let sdkInstance: WebVitalsSDK | null = null

// 全局变量存储父子页面的指标数据
let parentMetrics: any = null
let iframeMetrics: any = null
let hasReported = false
let iframeUrl: string | null = null
let currentUrl: string = window.location.href

// 清空所有指标数据的函数
const clearAllMetrics = () => {
  parentMetrics = null
  iframeMetrics = null
  hasReported = false
  iframeUrl = null
  console.log('已清空所有指标数据')
}

// 监听 iframe 发送的 Web Vitals 数据
const setupIframeMessageListener = () => {
  window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'WEB_VITALS_REPORT') {
      const iframeData = event.data.data

      iframeMetrics = {
        ...iframeData,
        source: event.data.source,
        subSource: event.data.subSource,
      }
      iframeUrl = window.location.href

      checkAndReport().catch(error => {
        console.error('checkAndReport 执行失败:', error)
      })
    }
  })
}

// 检查并上报指标
const checkAndReport = async () => {
  if (hasReported) return

  if (!parentMetrics) {
    console.log('等待父页面指标收集完成...')
    return
  }
  if (!iframeMetrics) {
    console.log('等待iframe指标收集完成...')
    return
  }

  if (!sdkInstance) {
    console.error('SDK 实例未初始化')
    return
  }

  const combinedMetrics = {
    pageUrl: (() => {
      try {
        const targetUrl = iframeUrl || window.location.href
        const url = new URL(targetUrl)
        let cleanHash = url.hash
        if (cleanHash.includes('?')) {
          cleanHash = cleanHash.split('?')[0]
        }
        cleanHash = cleanHash.replace(/\/\d+/g, '/{num}')
        const cleanUrl = url.origin + url.pathname + cleanHash
        const finalUrl = cleanUrl.replace(/#/g, '*')
        return finalUrl
      } catch (error) {
        let fallbackUrl = window.location.href
        fallbackUrl = fallbackUrl.replace(/\/\d+/g, '/{num}')
        fallbackUrl = fallbackUrl.replace(/#/g, '*')

        return fallbackUrl
      }
    })(),
    region: getRegion(),
    cityId: getCityId(),
    isIframeMode: true,
    ...parentMetrics,
    ...(() => {
      if (!iframeMetrics) return {}
      const excludeKeys = ['source', 'iframeOrigin', 'iframeLevel', 'subSource']
      return Object.keys(iframeMetrics).reduce((acc, key) => {
        if (excludeKeys.includes(key)) {
          acc[key] = iframeMetrics[key]
          return acc
        }
        acc[`iframe${key}`] = iframeMetrics[key] || 0
        return acc
      }, {})
    })(),
  }
  try {
    // 使用 trackPerformanceMetrics 方法上报
    await sdkInstance.trackPerformanceMetrics(combinedMetrics)
    console.log('性能指标上报成功:', combinedMetrics)
    hasReported = true

    clearAllMetrics()
  } catch (error) {
    console.error('Web Vitals 指标上报失败:', error)
  }
}

// 监听URL变化，重置指标数据
const setupUrlChangeListener = () => {
  window.addEventListener('popstate', () => {
    const newUrl = window.location.href
    if (newUrl !== currentUrl) {
      console.log('URL变化检测到，重置指标数据:', { 旧URL: currentUrl, 新URL: newUrl })
      clearAllMetrics()
      currentUrl = newUrl
    }
  })
  const originalPushState = history.pushState
  const originalReplaceState = history.replaceState
  history.pushState = function (...args) {
    originalPushState.apply(history, args)
    const newUrl = window.location.href
    if (newUrl !== currentUrl) {
      console.log('pushState URL变化检测到，重置指标数据:', { 旧URL: currentUrl, 新URL: newUrl })
      clearAllMetrics()
      currentUrl = newUrl
    }
  }
  history.replaceState = function (...args) {
    originalReplaceState.apply(history, args)
    const newUrl = window.location.href
    if (newUrl !== currentUrl) {
      console.log('replaceState URL变化检测到，重置指标数据:', { 旧URL: currentUrl, 新URL: newUrl })
      clearAllMetrics()
      currentUrl = newUrl
    }
  }
  window.addEventListener('hashchange', () => {
    const newUrl = window.location.href
    if (newUrl !== currentUrl) {
      console.log('hashchange URL变化检测到，重置指标数据:', { 旧URL: currentUrl, 新URL: newUrl })
      clearAllMetrics()
      currentUrl = newUrl
    }
  })
}

export const initPerformanceReport = () => {
  setupIframeMessageListener()
  setupUrlChangeListener()

  // 初始化 SDK 实例
  sdkInstance = new WebVitalsSDK({
    debug: false,
    realTimeReport: true,
    region: getRegion(),
    cityId: getCityId(),
    onReport: async (data) => {
      try {
        parentMetrics = { ...data }
        await checkAndReport()
      } catch (error) {
        console.log('Web Vitals SDK: Reported metrics error', error)
      }
    },
  })
}